module.exports = __webpack_public_path__ + "static/media/image_1_sp.9d00ba20.svg";